/**
* =========================================================================================
* Input Skeleton
* =========================================================================================
*/

import React from 'react';
import Skeleton from './index';

const LSkeleton = (props) => {

    const rowCount = props?.row ?? 20;

    return (
        <React.Fragment>
            {
                Array.from(Array(rowCount).keys()).map(a_number => {
                    return (
                        <div className="u_skeleton-list" key={a_number}>
                            {
                                Array.from(Array(props?.col ? props?.col : 1).keys()).map(number => {
                                    return (
                                        <div key={number}>
                                            <Skeleton height="30px" />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                })
            }
        </React.Fragment>
    );
}

export default LSkeleton;
